import {
  type GlobalTrackingAttributes,
  logNotFoundTrackingProperties,
} from "@b2bportal/core-tracking";
import type { FlightsPriceFreezeTrackingAttributes } from "./types";

export type TransformedEventProperties = {
  flightPriceFreezeProperties: FlightsPriceFreezeTrackingAttributes;
};

const isFlightsPriceFreezeTrackingAttributes = (
  attributes: Partial<GlobalTrackingAttributes>
): attributes is FlightsPriceFreezeTrackingAttributes => {
  if (typeof attributes !== "object") {
    return false;
  }

  if (attributes == null) {
    return false;
  }

  return (
    typeof attributes.is_quoted_price === "boolean" &&
    typeof attributes.pax_total === "number" &&
    typeof attributes.price_freeze_cap_local_currency === "number" &&
    typeof attributes.price_freeze_cap_usd === "number" &&
    typeof attributes.price_freeze_duration === "number" &&
    typeof attributes.price_freeze_fee_local_currency === "number" &&
    typeof attributes.price_freeze_fee_usd === "number" &&
    typeof attributes.price_freeze_price_per_unit_local_currency === "number" &&
    typeof attributes.price_freeze_price_per_unit_usd === "number" &&
    typeof attributes.price_freeze_total_price_local_currency === "number" &&
    typeof attributes.price_freeze_total_price_usd === "number" &&
    attributes.product_type === "air-price-freeze"
  );
};

const fallbackFlightsPriceFreezeTrackingAttributes = {
  is_quoted_price: false,
  pax_total: 1,
  price_freeze_cap_local_currency: 0,
  price_freeze_cap_usd: 0,
  price_freeze_duration: 0,
  price_freeze_fee_local_currency: 0,
  price_freeze_fee_usd: 0,
  price_freeze_price_per_unit_local_currency: 0,
  price_freeze_price_per_unit_usd: 0,
  price_freeze_total_price_local_currency: 0,
  price_freeze_total_price_usd: 0,
  product_type: "air-price-freeze",
} satisfies FlightsPriceFreezeTrackingAttributes;

const toFlightsPriceFreezeTrackingAttributes = (
  attributes: GlobalTrackingAttributes
): FlightsPriceFreezeTrackingAttributes => {
  if (!isFlightsPriceFreezeTrackingAttributes(attributes)) {
    logNotFoundTrackingProperties(
      "toFlightsPriceFreezeTrackingAttributes",
      "flights price freeze"
    );
    return fallbackFlightsPriceFreezeTrackingAttributes;
  }

  return attributes;
};

export const getTransformedEventProperties = ({
  trackingAttributes,
}: {
  trackingAttributes: GlobalTrackingAttributes;
}): TransformedEventProperties => ({
  flightPriceFreezeProperties:
    toFlightsPriceFreezeTrackingAttributes(trackingAttributes),
});
